const fixedBarNitification = () => {

    const moduloId = '#fixed-bar-notification';
    const allElementsPushDown = `
            body .lp-header header#topo,
            body #page.lp-header #banner-hero,
            header.site-header#masthead,
            header.site-header .container nav.menu_pravaler div#main-nav,
            #primary
        `;

    let init = () => {

        if (!$(`${moduloId}`)[0]) 
            return true;

        $(`${moduloId}`).removeClass('hide-bar');
        $(`${allElementsPushDown}`).addClass('module-fixed-bar-notification-mt-50');

        // Event click 'close'
        $(`${moduloId} .container .icon-close`).on(`click`, function() {
            $(`${moduloId}`).addClass('hide-bar');
            $(`${allElementsPushDown}`).addClass('module-fixed-bar-notification-deactivate');
        });
    }

    return {
       init: init
    };

};
$(window).on("load", fixedBarNitification().init);